import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "boarhead";

function GIBoarHead() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIBoarHead;